import React from 'react'
import './Menu.css'

type MenuProps = {
  className?: string
}
const Menu: React.FC<MenuProps> = ({ children, ...props }) => {
  return (
    <ul {...props}>
      {children}
    </ul>
  )
}
export default Menu